export const SIDEBAR_WIDTHS = {
  EXPANDED: "17.1875rem",
  COLLAPSED: "5rem",
  SUBMENU: "14rem",
} as const;

export const SIDEBAR_BREAKPOINT = 1280;
export const SIDEBAR_MOBILE_BREAKPOINT = 1024;
